export const Age_keys = {
  YoungerThan18yearSold: "Younger than 18 years old",
  Old18_24years:'18 – 24 years old',
  Old25_34years:'25 – 34 years old',
  Old35_55years:'35 – 55 years old',
  Old56years:'56 Years old and above',
};
